<app-header [sections]="sections">
</app-header>
<main class="inm-layout-main">
    <router-outlet></router-outlet>
</main>
<footer class="inm-layout-footer">&copy; Inmar, Inc.</footer>